// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"676":"b1e550a007f647a78857","908":"31cc9518797853101975"}[chunkId] + ".js";
};